module.exports = __webpack_public_path__ + "1b4d8efb8dd44b934f477be2a2b5952c.pdf";